import Vue from 'vue';
import Skeleton from 'primevue/skeleton';

Vue.component('Skeleton', Skeleton);
